/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TakeSnapshotRequest {
  /**
  * Eon-assigned ID of the vault to store the snapshot in. 
  */
  'vaultId': string;
  /**
  * Number of days to retain the snapshot.
  */
  'retentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TakeSnapshotRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

